import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getSelfieRequired = (state) => resolveProp('profile.data.idvSelfieRequired', state);

export default createSelector(getSelfieRequired, (selfieRequired) => selfieRequired);
